import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./pages/Layout";
import LocationProvider from "./context/LocationContext";

// Lazy loading for better performance
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const BookRide = lazy(() => import("../src/pick_your_ride/BookRide"));
const ContactPickupForm = lazy(() => import("./booking_form/ContactPickupForm"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Hero = lazy(() => import("./components/Hero/Hero"));
const LocalRide = lazy(() => import("./pick_your_ride/LocalRide"));

const App = () => {
  return (
    <LocationProvider>
        <Suspense fallback={<div className="flex justify-center text-primary font-bold items-center h-screen animate-ping">Raahi<span className="text-secondary">Sathi</span> </div>}>
          <Routes>
            {/* Main Layout */}
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="hero" element={<Hero />} />
              <Route path="about" element={<About />} />
              <Route path="bookride" element={<BookRide />} />
              <Route path="localride" element={<LocalRide />} />
              <Route path="contactform" element={<ContactPickupForm />} />
            </Route>
            {/* 404 Not Found Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
    </LocationProvider>
  );
};

export default App;